import React, { FC } from 'react';
import { Content } from '../../components/content';
import { Header } from '../../components/header/header';
import { Page } from '../../components/page';
import { IShipTo, ISoldTo } from '../../graphql/types';
import { SoldToBody } from './body';
import { GetSoldToShipToByIdQuery } from './queries/sold-to-ship-to-by-id';
import { SOLD_TO_PAGE_ROUTE } from './route';

export const SoldToPage: FC<{
  soldToId: string;
  shipToId?: string;
}> = ({ soldToId, shipToId }) => {
  return (
    <Page
      data-type="page"
      data-page={SOLD_TO_PAGE_ROUTE}
      data-sold-to-id={soldToId}
      data-ship-to-id={shipToId}
    >
      <Header />
      <Content>
        <GetSoldToShipToByIdQuery
          soldToId={soldToId}
          shipToId={shipToId}
          render={(soldTo: ISoldTo, shipTo?: IShipTo) => {
            return <SoldToBody soldTo={soldTo} shipTo={shipTo} />;
          }}
        />
      </Content>
    </Page>
  );
};
